"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastChats = void 0;
const uuid_1 = require("uuid");
const mappers_1 = require("../../mappers");
const models_1 = require("../../models");
const roleAccess_1 = require("../../roleAccess/roleAccess");
const Observable_1 = require("../../socket/Observable");
const utils_1 = require("../../utils");
const CollectionUtils_1 = require("../../utils/CollectionUtils");
const DomainEvents_1 = require("../../utils/DomainEvents");
const BroadcastInfoChat_1 = require("./BroadcastInfoChat");
class BroadcastChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        this.isChatSearchCleared = false;
        this.removeListeners = [];
        this.changeListeners = [];
        this.isUpdatedSearch = (requestFilter, chatList) => {
            if (chatList.chatFilters) {
                return (JSON.stringify(requestFilter) !== JSON.stringify(chatList.chatFilters));
            }
            return false;
        };
        this.isPaginatedFilter = (chatList, requestFilter) => {
            if (!requestFilter && chatList.searchMatchCount) {
                return (chatList.hasNext && chatList.searchMatchCount > chatList.chats.length);
            }
            return false;
        };
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.socketAdapter = socketAdapter;
        this.config = config;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.addChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.deleteChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.chatInfoUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.chatListUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.organizationUser
            .getNetworkManager()
            .registerSocketAuthSuccessListener((lastHeartbeatReceivedAt, abortContext) => __awaiter(this, void 0, void 0, function* () {
            yield this.syncChats(lastHeartbeatReceivedAt, abortContext);
            this.notifyChange();
        })));
    }
    destroy() {
        this.removeAllListeners();
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this.getChats()));
    }
    removeAllListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    getChat(groupId) {
        return this.getChatFromStorage(groupId);
    }
    addChatListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getNewChatEventKey)(this.organizationUser.getOrganization().organizationId, this.getChatType()), (data) => {
            const chatLog = (0, mappers_1.broadcastChatMapper)(data, this.userDirectory, this.organizationUser, this.httpAdapter);
            this.addChats(cb, chatLog);
        });
    }
    updateChatListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getUpdateChatEventKey)(this.organizationUser.getOrganization().organizationId, this.getChatType()), (data) => {
            const chatLog = (0, mappers_1.broadcastChatMapper)(data.chatLog, this.userDirectory, this.organizationUser, this.httpAdapter);
            this.updateChatToStorage(cb, chatLog, data.message);
        });
    }
    deleteChatListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getDeleteChatEventKey)(this.organizationUser.getOrganization().organizationId, this.getChatType()), (data) => __awaiter(this, void 0, void 0, function* () {
            cb(this.hhnStorage.chatsStorage.deleteChat(models_1.GROUP_TYPE.BROADCAST, data.from));
        }));
    }
    addChats(cb, chatLog) {
        const newChat = Object.assign({}, chatLog);
        this.hhnStorage.chatsStorage.upsertChat(models_1.GROUP_TYPE.BROADCAST, newChat, false, true);
        const chatList = this.hhnStorage.chatsStorage.getChatListByType(this.getGroupType());
        cb(chatList);
    }
    addMembers(data, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const selectedMemberIds = data.membersToAdd.map(member => member.userId);
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.ADD_MEMBERS))
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                const requestPayload = {
                    membersToAdd: selectedMemberIds,
                    id,
                };
                const addedMember = yield this.httpAdapter
                    .getChatAdapter()
                    .addBroadcastMembers(requestPayload);
                if (!addedMember) {
                    throw new utils_1.HhnException("Error while adding members");
                }
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    updateBroadcastInfo(cb, updatedBroadcastInfo) {
        let chatList = this.getChats();
        let chatListItem = chatList.chats.find(chat => chat.broadcastInfo.id === updatedBroadcastInfo.id);
        if (chatListItem) {
            chatListItem = Object.assign(Object.assign({}, chatListItem), { broadcastInfo: updatedBroadcastInfo });
            const updatedChats = chatList.chats.map(chat => chat.id === chatListItem.id ? Object.assign(Object.assign({}, chat), chatListItem) : chat);
            chatList = Object.assign(Object.assign({}, chatList), { chats: updatedChats });
            this.setChats(chatList);
            cb(chatList);
        }
    }
    getBroadcastRequestData(data) {
        let requestPayload;
        if ("membersToAdd" in data) {
            requestPayload = Object.assign(Object.assign(Object.assign({}, (data.name && { name: data.name })), (data.about && { about: data.about })), { membersToAdd: data.membersToAdd });
        }
        else {
            requestPayload = Object.assign({ id: data.id, name: data.name }, (data.about && { about: data.about }));
        }
        return requestPayload;
    }
    addChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.CREATE_BROADCAST)) {
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                }
                yield this.httpAdapter
                    .getChatAdapter()
                    .addBroadcastGroup(this.getBroadcastRequestData(data));
            }
            catch (e) {
                throw e;
            }
        });
    }
    deleteChat(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.DELETE_BROADCAST)) {
                    throw new Error(utils_1.ErrorMessages.noAccessFound);
                }
                yield this.httpAdapter.getChatAdapter().deleteBroadcastGroup(id);
            }
            catch (e) {
                throw e;
            }
        });
    }
    chatInfoUpdateListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(DomainEvents_1.DomainEvents.UPDATE_CHAT_LIST_ITEM, this.organizationUser.getOrganization().organizationId), (data) => {
            const groupHasChat = this.getChats().chats.some(chat => chat.broadcastInfo.id === data.info._id);
            if (groupHasChat) {
                const broadcastInfo = data.info;
                const updatedBroadcastInfo = (0, mappers_1.broadcastInfoMapper)(broadcastInfo, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
                this.updateBroadcastInfo(cb, updatedBroadcastInfo);
            }
        });
    }
    fetchChats() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.organizationUser.hasAccess(roleAccess_1.FEATURES.VIEW_BROADCAST))
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            if (this.isChatSearchCleared) {
                this.hhnStorage.chatsStorage.resetChatListByType(models_1.GROUP_TYPE.BROADCAST);
                this.isChatSearchCleared = false;
            }
            const chatList = this.getChats();
            if (chatList.hasNext) {
                const chatListResponse = yield this.httpAdapter
                    .getChatAdapter()
                    .getBroadcastChatList(this.getRequestData());
                if (!chatListResponse.isAborted) {
                    const newChats = (0, mappers_1.broadcastChatsMapper)(chatListResponse.data, this.userDirectory, this.organizationUser, this.httpAdapter);
                    this.populateChatList(newChats, "APPEND", (_, newChats) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const { chats, chatFilters } = newChats, restData = __rest(newChats, ["chats", "chatFilters"]);
                        return Object.assign({}, restData);
                    }, false);
                    this.notifyChange();
                }
            }
        });
    }
    syncChats(lastHeartbeatReceivedAt, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const chatType = this.getChatType();
            const chatRequestBody = {
                chatType,
                hiddenChats: false,
                lastSyncedAt: lastHeartbeatReceivedAt,
                total: 0,
                limit: utils_1.HHNConstants.SYNC_PAGINATION_LIMIT,
            };
            const chatListResponse = yield this.httpAdapter
                .getChatAdapter()
                .syncBroadcastChatList(chatRequestBody, this.organizationUser.getOrganization().organizationId, abortContext);
            if (!chatListResponse.isAborted) {
                const newChats = (0, mappers_1.broadcastChatsMapper)(chatListResponse.data, this.userDirectory, this.organizationUser, this.httpAdapter);
                this.populateChatList(newChats, "PREPEND", (existingChats, newChats) => {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const { chats, limit, hasNext, total, page } = newChats, rest = __rest(newChats, ["chats", "limit", "hasNext", "total", "page"]);
                    return Object.assign(Object.assign({}, this.pageData(existingChats)), rest);
                }, true);
            }
        });
    }
    pageData(chats) {
        return {
            limit: chats.limit,
            hasNext: chats.hasNext,
            total: chats.total,
            page: chats.page,
        };
    }
    populateChatList(newChats, order, mergeHandler, showMergedChatsOnTop) {
        let chatList = this.getChats();
        const nonDeletedChats = Object.assign(Object.assign({}, newChats), { chats: newChats.chats.filter(c => c.status !== models_1.CHAT_STATUS.DELETED) });
        if (chatList) {
            const { mergedItems } = (0, CollectionUtils_1.mergeAppendToArray)(chatList.chats, nonDeletedChats.chats, c => c.id, order, showMergedChatsOnTop);
            if (chatList) {
                chatList = Object.assign(Object.assign({}, mergeHandler(chatList, nonDeletedChats)), { chats: mergedItems });
            }
        }
        this.setChats(chatList);
    }
    getRequestData() {
        const chatList = this.getChats();
        const request = {
            chatType: models_1.CHAT_TYPE.BROADCAST,
            limit: utils_1.HHNConstants.BROADCAST_PAGINATION_LIMIT,
            total: chatList && chatList.chats.length > 0 ? chatList.chats.length : 0,
        };
        return request;
    }
    // @ts-ignore
    getStoredChat(chatId) {
        const chatList = this.getChats();
        if (chatList) {
            const foundChat = chatList.chats.find(chat => chat.broadcastInfo.id === chatId);
            if (foundChat) {
                return this.getOrCreateChatFromStorage(chatId, foundChat.broadcastInfo, false);
            }
        }
    }
    getChats() {
        return this.hhnStorage.chatsStorage.getChatListByType(models_1.GROUP_TYPE.BROADCAST);
    }
    setChats(chatList) {
        this.hhnStorage.chatsStorage.setChatListByType(models_1.GROUP_TYPE.BROADCAST, chatList);
    }
    getGroupType() {
        return models_1.GROUP_TYPE.BROADCAST;
    }
    getFreshChat(id, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const broadcastInfoReponse = yield this.fetchChatInfo(id, undefined, context);
            if (!broadcastInfoReponse.isAborted) {
                this.getOrCreateChatFromStorage(id, broadcastInfoReponse.data, true);
                this.notifyChange();
            }
        });
    }
    getChatFromStorage(chatId) {
        return this.hhnStorage.chatStorage.getBroadcastChat(chatId);
    }
    touchChat(chatId) {
        return this.hhnStorage.chatStorage.touchBroadcastChat(chatId);
    }
    fetchChatInfo(chatId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const infoResponse = yield this.httpAdapter
                .getChatAdapter()
                .getBroadcastInfo(chatId, source, context);
            if (!infoResponse.isAborted) {
                return (0, utils_1.CompletedResult)((0, mappers_1.broadcastInfoMapper)(infoResponse.data, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter));
            }
            return utils_1.AbortedResult;
        });
    }
    getUnreadMessageCount(chatId) {
        var _a;
        return (((_a = this.hhnStorage.chatsStorage.getChatByGroupType(this.getGroupType(), chatId)) === null || _a === void 0 ? void 0 : _a.unreadCount) || 0);
    }
    getLastMessageRead() {
        return;
    }
    getIsMember() {
        // Broadcast chats - users are always members if they can see the broadcast
        return true;
    }
    getOrCreateChatFromStorage(chatId, broadcastInfo, shouldMergeGroupInfo) {
        let chat = this.getChatFromStorage(chatId);
        if (!chat) {
            chat = new BroadcastInfoChat_1.BroadcastInfoChat(broadcastInfo, this.organizationUser, this.config, this.httpAdapter, this.socketAdapter, this.userDirectory, this);
            chat.init();
            this.hhnStorage.chatStorage.addChatByType(this.getGroupType(), chat);
        }
        else {
            /*
            When a user opens a chat for the first time, getStoredChat is called and enters the 'if' condition of this method, creating the chat in storage. Then, getFreshChat is called, and we need to merge the chatInfo with the latest chatInfo returned from getFreshChat. The second time the user opens the chat, getStoredChat is called and enters the 'else' block, but we already have the latest information, so there is no need to merge or update chatInfo.
      
            Example:
            User opens chat 1:
              getStoredChat - chatStorage.chat(P) - Create
              getFreshChat - chatStorage.chat(P) <- (F) - Current (Merging) - Proposed (Overwrite)
      
            User opens chat 2
      
            User opens chat 1 again:
              getStoredChat - chatStorage.chat(F) <- Current (Overwrite) - Proposed (Do nothing)
              getFreshChat - chatStorage.chat(F) <- (F) - Current (Merging) - Proposed (Overwrite)
            */
            if (shouldMergeGroupInfo) {
                chat.updateChatInfo(Object.assign(Object.assign({}, chat.chatInfo), broadcastInfo));
            }
        }
        return chat;
    }
    updateChatToStorage(cb, chatLog, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    message) {
        let updatedChat = Object.assign({}, chatLog);
        const chatList = this.getChats();
        const existingChat = chatList.chats.find(chat => chat.id === updatedChat.id);
        if (existingChat) {
            updatedChat = Object.assign(Object.assign({}, updatedChat), { broadcastInfo: existingChat.broadcastInfo, isMember: existingChat.isMember });
            this.hhnStorage.chatsStorage.upsertChat(models_1.GROUP_TYPE.BROADCAST, updatedChat, false, true);
            cb(this.getChats());
        }
    }
    searchChats(search) {
        const chatList = this.getChats();
        return (0, utils_1.searchGroupsByName)(search, chatList.chats);
    }
    getChatType() {
        return models_1.CHAT_TYPE.BROADCAST;
    }
    chatListUpdateListener(cb) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.groupEventKey)(this.organizationUser.getOrganization().organizationId, models_1.GROUP_TYPE.BROADCAST), (chatList) => {
            cb(chatList);
        });
    }
    removeMember(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const hasRemoveMembersAccess = this.organizationUser.hasAccess(roleAccess_1.FEATURES.REMOVE_MEMBERS);
            if (!hasRemoveMembersAccess) {
                throw new Error(utils_1.ErrorMessages.noAccessFound);
            }
            yield this.httpAdapter.getChatAdapter().removeBroadcastMember(data);
        });
    }
}
exports.BroadcastChats = BroadcastChats;
